// removed by extract-text-webpack-plugin
module.exports = {"medium":"(min-width:768px)","device":"browser__device___1sggI","deviceContent":"browser__deviceContent___2SYNT","img":"browser__img___2EZrS"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Browser/browser.css
// module id = 155
// module chunks = 0